<template>
  <div class="auth-check" :class="{'auth-check-ac': ac}">
    <header-component
      :is-soon="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.svg"
      class="header-component"
    />
    <!-- body -->
    <div class="auth-check_body">
      <div class="mobile-container">
        <h2 class="auth-check_title">Para sua segurança responda as perguntas abaixo:</h2>
        <div>
          <authenticity-questions
            :steps="steps"
            :step="currentStep"
            :timer="timerCounter"
            :question="question"
            :options="options"
            v-model="answer"
          />
        </div>
      </div>
    </div>
    <div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>
    <!-- end body -->
    <!-- footer -->
    <div class="auth-check_footer">
      <div class="mobile-container">
        <div class="auth-check_footer_button">
          <action-button
            theme="dark_full"
            @click="onClickAdvance"
            :disabled="AdvanceButtonDisabled"
          >Continuar</action-button>
        </div>
      </div>
    </div>
    <!-- end footer -->
    <!-- error alert -->
    <alert
      :danger="alertType === 'danger'"
      :warning="alertType === 'warning'"
      :callCenter="alertType === 'call-center'"
      :description="alertDescription"
      :message="alertMessage"
      @close="alertCallback"
      v-if="alertActive"
    />
    <!-- end error alert -->
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Timer, {TimerStatusEnum} from '@/core/timer'
  import ActionButton from '@/components/ActionButton'
  import AuthenticityQuestions from '@/components/AuthenticityQuestions'
  import Alert from '@/components/Alert'
  import HeaderComponent from '@/components/HeaderComponent'
  import ChangeService from '@/services/change'
  import trackEvent from '@/services/trackEvent'
  // import * as Cookies from "tiny-cookie";
  // import * as jwtDecode from "jwt-decode";

  // TODO: As telas precisam de middleware de segurança, porque o usuário
  // pode avançar digitando a URL da página.

  const INITIALIZATION_DATA = {
    TIMER_COUNT: 60,
    steps: 3,
    currentStep: 0,
    submitting: false,
    errorCount: 0,
    loaded: false,
    loading: false,
    options: [],
    question: '',
    answer: '',
    alertActive: false,
    alertType: '',
    alertDescription: '',
    alertMessage: '',
    alertCallback: () => {}
  }
  const RETEST_TIME = 'XX'

  export default {
    components: {
      ActionButton,
      AuthenticityQuestions,
      Alert,
      HeaderComponent,
    },
    data() {
      return {...INITIALIZATION_DATA}
    },
    computed: {
      routerStep() {
        return this.$route.params.step
      },
      AdvanceButtonDisabled() {
        return (
          !this.answer
          || this.expired
          || this.submitting
          || this.errorCount > 1
        )
      },
      expired() {
        return (this.timerStatus === TimerStatusEnum.EXPIRED)
      },
      ...mapState({
        ac: state => state.ac,
        customer: state => state.customer,
        timerCounter: state => state.timerCounter,
        timerStatus: state => state.timerStatus
      }),
    },
    watch: {
      routerStep() {
        // essa gambiarra resolve um problema do vue-router. O vue-router
        // não reconstroi o componente nos passos 2 e 3.
        this.reset()
        this.initialize()
      },
      expired() {
        this.showExpirationAlert()
      }
    },
    methods: {
      initialize() {
        this.importCurrentStep()
        this.initializePageData()
        this.initializeTimer()
      },
      reset() {
        Object.assign(this.$data, INITIALIZATION_DATA);
      },
      advance() {
        if (this.currentStep == 1 || this.currentStep == 2) {
          this.$router.push({
            name: 'authenticity-check',
            params: {
              step: (this.currentStep + 1).toString()
            }
          })
        } else if (this.currentStep == 3) {
          this.$router.push({name: 'chip'})
        } else {
          throw new Error('Invalid step.')
        }
      },
      validate() {
        if (this.expired) {
          return false
        }

        if (this.answer == '') {
          return false
        }

        if (this.errorCount > 1) {
          return false
        } 

        return true
      },
      submit() {
        this.submitting = true
        if (this.validate()) {
          this
            .checkAuthenticityQuestion()
            .then((response) => {
              if (response.data.internalCode == '1') {
                // this.$store.dispatch('accessKey', Cookies.get('access_key'))
                // this.$store.dispatch('metadataCookie', Cookies.get('metadata'))
                // this.$store.dispatch('customer', jwtDecode(this.metadataCookie))
                this.unlockAuthenticityQuestion()
                this.advance()
              } else {
                this.submitting = false
                this.handleAuthenticityQuestionError()
              }
            })
            .catch(() => {
                this.submitting = false
                this.handleAuthenticityQuestionError()
            });
        } else {
          this.submitting = false
        }
      },
      unlockAuthenticityQuestion() {
        if (this.currentStep == 1) {
          this.$store.dispatch('authenticityCheckStep1Answer', this.answer)
        } else if (this.currentStep == 2) {
          this.$store.dispatch('authenticityCheckStep2Answer', this.answer)
        } else if (this.currentStep == 3) {
          this.$store.dispatch('authenticityCheckStep3Answer', this.answer)
        }
      },
      checkAuthenticityQuestion() {
        return ChangeService.checkAuthenticityQuestion(
          this.currentStep,
          this.answer
        )
      },
      loadQuestion() {
        this.loading = true
        ChangeService
          .loadAuthenticityQuestion(this.currentStep)
          .then((response) => {
            this.loading = false
            if (response.data.internalCode == '1') {
              this.pushLoadedQuestion(response.data.data);
            } else {
              this.showErrorAlertLoadQuestion(response.data)
            }
          })
          .catch((error) => {
            this.loading = false
            this.showErrorAlertLoadQuestion(error.response.data)
          })
      },
      pushLoadedQuestion(data) {
        if (this.currentStep == 1) {
          this.$store.dispatch('authenticityCheckStep1Loaded', true)
          this.$store.dispatch('authenticityCheckStep1Question', data.question)
          this.$store.dispatch('authenticityCheckStep1Options', data.options)
        } else if (this.currentStep == 2) {
          this.$store.dispatch('authenticityCheckStep2Loaded', true)
          this.$store.dispatch('authenticityCheckStep2Question', data.question)
          this.$store.dispatch('authenticityCheckStep2Options', data.options)
        } else if (this.currentStep == 3) {
          this.$store.dispatch('authenticityCheckStep3Loaded', true)
          this.$store.dispatch('authenticityCheckStep3Question', data.question)
          this.$store.dispatch('authenticityCheckStep3Options', data.options)
        }

        this.loaded = true
        this.question = data.question
        this.options = data.options
      },
      importCurrentStep() {
        const step = Number(this.$route.params.step)
        if (isNaN(step) || step < 1 || step > this.steps) {
          this.currentStep = 1
        } else {
          this.currentStep = step
        }
      },
      initializeTimer() {
        if (Timer.isNotStarted()) {
          Timer.start(this.TIMER_COUNT)
        }
      },
      initializePageData() {
        this.restoreDataFromStore()

        if (!this.loaded) {
          this.loadQuestion()
        }
      },
      restoreDataFromStore() {
        this.errorCount = this.$store.state.authenticityCheckErrorCount
        if (this.currentStep == 1) {
          this.loaded = this.$store.state.authenticityCheckStep1Loaded
          this.options = this.$store.state.authenticityCheckStep1Options
          this.question = this.$store.state.authenticityCheckStep1Question
          this.answer = this.$store.state.authenticityCheckStep1Answer
        } else if (this.currentStep == 2) {
          this.loaded = this.$store.state.authenticityCheckStep2Loaded
          this.options = this.$store.state.authenticityCheckStep2Options
          this.question = this.$store.state.authenticityCheckStep2Question
          this.answer = this.$store.state.authenticityCheckStep2Answer
        } else if (this.currentStep == 3) {
          this.loaded = this.$store.state.authenticityCheckStep3Loaded
          this.options = this.$store.state.authenticityCheckStep3Options
          this.question = this.$store.state.authenticityCheckStep3Question
          this.answer = this.$store.state.authenticityCheckStep3Answer
        } else {
          throw new Error('Invalid step.')
        }
      },
      showIncorrectAnswerAlert() {
        this.showAlert(
          'danger',
          'Resposta incorreta',
          `Você pode tentar mais uma vez. Caso erre novamente, aguarde ${RETEST_TIME} minutos e refaça o processo de troca de chip.`,
          () => {
            this.trackIncorrectAnswer()
            this.hideAlert()
          }
        )
      },
      showNotAuthenticatedAlert() {
        this.showAlert(
          'danger',
          'Você errou novamente',
          'Vá até uma loja TIM para realizar a troca de chip presencialmente.',
          () => {
            this.trackNotAuthenticated()
            this.hideAlert()
          }
        )
      },
      showExpirationAlert() {
        // TODO: implementar callback e revisar mensagem
        this.showAlert(
          'danger',
          'Seu tempo expirou',
          'Vá até uma loja TIM para realizar a troca de chip presencialmente.',
          () => {
            this.hideAlert()
          }
        )
      },
      showErrorAlertLoadQuestion(data) {
        // TODO: implementar callback
        this.showAlert(
          'danger',
          data.desc,
          data.message,
          () => {
            this.hideAlert()
          }
        )
      },
      showAlert(type, description, message, callback) {
        this.alertType = type
        this.alertDescription = description
        this.alertMessage = message
        this.alertCallback = callback
        this.alertActive = true
      },
      hideAlert() {
        this.alertType = ''
        this.alertDescription = ''
        this.alertMessage = ''
        this.alertCallback = () => {}
        this.alertActive = false
      },
      handleAuthenticityQuestionError() {
        this.errorCount++
        this.$store.dispatch('authenticityCheckErrorCount', this.errorCount)
        if (this.errorCount == 1) {
          this.showIncorrectAnswerAlert()
        } else if (this.errorCount >= 2) {
          this.showNotAuthenticatedAlert()
        }
      },
      trackAdvance() {
        trackEvent.track({
          'user.login': this.customer.login,
          'user.loginType': this.customer.loginType,
          'user.lineType': this.customer.lineType,
          'user.segment': this.customer.segment,
          'user.subSegment':  this.customer.subSegment,
          'user.planCode':  this.customer.planCode,
          'user.planName':  this.customer.planDesc,
          'channel': trackEvent.getChannel(),
          'event-category': 6,
          'event-label': `Perda Roubo Defeito Pergunta ${this.currentStep}`,
          'event-value': '',
          'event-status': 'Sucesso',
          'event-interactionNumber': '',
          'event-error': '',
          'event-errorDetail': ''
        })
      },
      trackIncorrectAnswer() {
        trackEvent.track({
          'user.login': this.customer.login,
          'user.loginType': this.customer.loginType,
          'user.lineType': this.customer.lineType,
          'user.segment': this.customer.segment,
          'user.subSegment':  this.customer.subSegment,
          'user.planCode':  this.customer.planCode,
          'user.planName':  this.customer.planDesc,
          'channel': trackEvent.getChannel(),
          'event-category': 6,
          'event-label': 'Perda Roubo Defeito Resposta Incorreta 1',
          'event-value': '',
          'event-status': 'Sucesso',
          'event-interactionNumber': '',
          'event-error': '',
          'event-errorDetail': ''
        })
      },
      trackNotAuthenticated() {
        trackEvent.track({
          'user.login': this.customer.login,
          'user.loginType': this.customer.loginType,
          'user.lineType': this.customer.lineType,
          'user.segment': this.customer.segment,
          'user.subSegment':  this.customer.subSegment,
          'user.planCode':  this.customer.planCode,
          'user.planName':  this.customer.planDesc,
          'channel': trackEvent.getChannel(),
          'event-category': 6,
          'event-label': 'Perda Roubo Defeito Resposta Incorreta 2',
          'event-value': '',
          'event-status': 'Sucesso',
          'event-interactionNumber': '',
          'event-error': '',
          'event-errorDetail': ''
        })
      },
      onClickAdvance() {
        this.trackAdvance()
        this.submit()
      }
    },
    mounted() {
      this.initialize()
    }
  };
</script>

<style lang="scss" scoped>
  .auth-check {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    padding-top: 96px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .auth-check-ac.auth-check {
    background-color: #1c1c1c;
  }

  .auth-check_body {
    flex: 1;
  }

  .auth-check_title {
    display: block;
    margin: 0;
    padding: 0;
    color: #181818;
    text-align: center;
    font-family: timsans_thin;
    font-size: 2rem;
    line-height: normal;
  }

  .auth-check-ac .auth-check_title {
    color: #FFFFFF;
  }

  .auth-check_footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .auth-check_footer_button {}

  @media (min-width: 768px) {
    .auth-check {
      display: grid;
      grid-auto-columns: 50% 50%;
      grid-template-areas:
                    'header header'
                    'body background'
                    'footer background'
    ;
      position: absolute;
      padding-top: 0;
    }

    .header-component {
      width: 45%;
      grid-area: header;
    }

    .mobile-container {
      width: 400px;
      max-width: 400px;
    }

    .auth-check-ac.auth-check {
      background-color: #1c1c1c;
    }

    .auth-check_body {
      grid-area: body;
      margin-top: 139px;
    }

    .background-desktop {
      grid-area: background;
      width: 100%;
      height: 100vh;
      flex: 1;
      background: url("../assets/images/desktop@3x.png") no-repeat;
      background-size: cover;
    }

    .background-desktop-black {
      grid-area: background;
      width: 100%;
      height: 100vh;
      display: block;
      background: url("../assets/images/desktop-black.png") no-repeat;
      background-size: cover;
    }

    .auth-check_title {
      width: 400px;
      display: block;
      margin: 0;
      padding: 0;
      color: #181818;
      text-align: center;
      font-family: timsans_thin;
      font-weight: 300;
      font-size: 2rem;
      line-height: normal;
    }

    .auth-check-ac .auth-check_title {
      color: #FFFFFF;
    }

    .auth-check_footer {
      width: 100%;
      grid-area: footer;
      padding-top: 40px;
      padding-bottom: 40px;
    }

    .auth-check_footer_button {}

  }
</style>